import { DataSource, HorizontalSpacer, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierTargetLaneRate extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    sourceCarrierLaneRate: DataSource;
    switchPtToPt: Switch;
    textboxDescription: Textbox;
    textboxDestination: Textbox;
    textboxDestinationCode: Textbox;
    textboxDestinationCounties: Textbox;
    textboxDestinationState: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxExtraStopPay: Textbox;
    textboxFuelSurchargePay: Textbox;
    textboxLastUsed: Textbox;
    textboxMaxPayMethod: Textbox;
    textboxMaxPayRate: Textbox;
    textboxOrigin: Textbox;
    textboxOriginCode: Textbox;
    textboxOriginCounties: Textbox;
    textboxOriginState: Textbox;
    textboxTargetPayMethod: Textbox;
    textboxTargetPayRate: Textbox;
    textboxTimesUsed: Textbox;
}
